/**
 * LES RÈGLES DE PLURIEL des messages d'interface (`i18n/locales/*.json`).
 * ============================================================================
 * Chantier multilingue, lot 2. Module pur : il sert à `i18n/i18n.config.ts`
 * (le site) ET aux tests (`tests/composables/i18n-rendu.mjs`), pour que les
 * tests rendent les messages avec les règles qui tournent vraiment.
 *
 * 🔴 LE PIÈGE. La règle par défaut de vue-i18n met 0 au PLURIEL (« 0 dons ») :
 * c'est l'anglais. Le français met 0 au SINGULIER (« 0 don »), comme le code
 * d'avant le lot 2 (`count > 1 ? many : one`). Sans règle `fr` explicite, tout
 * décompte nul changeait de forme sur les pages françaises.
 *
 * Un message a deux formes (`{n} don | {n} dons`) ou trois, la première pour
 * zéro (`aucun don | {n} don | {n} dons`) — la même convention que vue-i18n.
 */

/** Deux formes : l'index de la forme plurielle selon la langue. */
const PLURIEL = {
  // Français : 0 et 1 au singulier (CLDR : i = 0,1).
  fr: n => n >= 2,
  // Anglais et espagnol : tout sauf 1 au pluriel (« 0 donations », « 0 donaciones »).
  en: n => n !== 1,
  es: n => n !== 1,
}

function regle(estPluriel) {
  return (choix, nombreDeFormes) => {
    const n = Math.abs(Number(choix) || 0)
    if (nombreDeFormes >= 3) return n === 0 ? 0 : n === 1 ? 1 : 2
    return estPluriel(n) ? 1 : 0
  }
}

/** `pluralRules` de vue-i18n, par code de langue du site. */
export const REGLES_PLURIEL = Object.fromEntries(Object.entries(PLURIEL).map(([langue, f]) => [langue, regle(f)]))
